import React from 'react';
import './CustomSelect.css';

const CustomSelect = ({
  onChange,
  option,
  selected,
  error,
  disabled = false,
  style,
  placeholder = "Select"
}) => {
  return (
    <div className="w-100 d-flex flex-column">
      <select
        disabled={disabled}
        className={disabled ? "custom-select-disabled" : 'custom-select'}
        onChange={onChange}
        value={selected}
        style={style}
        required
      >
        <option value="" hidden>
          {placeholder}
        </option>
        {option.map((data) => (
          <option value={data.value} key={data.value}>
            {data.label}
          </option>
        ))}
      </select>
      {error && <div className='text-danger'>{error}</div>}
    </div>
  );
};

export default CustomSelect;